import { render, staticRenderFns } from "./CPDueDiligenceForm.vue?vue&type=template&id=5401f259&scoped=true&"
import script from "./CPDueDiligenceForm.vue?vue&type=script&lang=ts&"
export * from "./CPDueDiligenceForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5401f259",
  null
  
)

export default component.exports